import React from 'react'
import { VideoCameraIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import EpisodeList from './EpisodeList'
import CreateEpisode from "./CreateEpisode"
import EditEpisode from "./EditEpisode"
import RouteKeys from 'constants/route-keys'
import EditEpisodeWithErrorBoundary from './EditEpisode'


const _routes: RouteElement[] = [
    {
        // use empty string so the list renders at /episodes
        route: '',
        title: 'Episodes',
        key: RouteKeys.EPISODE,
        component: EpisodeList,
        icon: VideoCameraIcon,
        display: true
    }
]

const Episodes = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {_routes.map(route => (
                        <React.Fragment key={'episodes-frag-' + route.route}>
                            {/* main list ('' means '/episodes') */}
                            <Route path={route.route} key={'episodes' + route.route} element={<route.component />} />
                            {/* nested create and edit paths */}
                            <Route path={`create`} key={'episodes-create'} element={<CreateEpisode />} />
                            {/* support both /episodes/:id/edit and /episodes/edit/:id */}
                            <Route path={`:id/edit`} key={'episodes-edit-id'} element={<EditEpisodeWithErrorBoundary />} />
                            <Route path={`edit/:id`} key={'episodes-edit'} element={<EditEpisodeWithErrorBoundary />} />
                        </React.Fragment>
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default Episodes